import './styles/details-header.scss'

import React       from 'react'
import PropTypes   from 'prop-types'

import { Header, Icon } from 'semantic-ui-react'

const TYPE_ICON_MAPPING = {
  DataSystem:     'cubes',
  DeliveryConfig: 'cogs',
  Integration:    'braille',
  Job:            'shipping fast',
  DataSource:     'arrow alternate circle right outline',
  Endpoint:       'stop circle',
  Log:            'envelope open outline',
}

export default class DetailsHeader extends React.Component {
  static propTypes = {
    title:       PropTypes.string.isRequired,
    description: PropTypes.string,
    type:        PropTypes.oneOf(Object.keys(TYPE_ICON_MAPPING)).isRequired,
    children:    PropTypes.node,
  }

  render() {
    const { type, title, description } = this.props

    const icon = TYPE_ICON_MAPPING[type]

    return (
      <div className="details-header">
        <Header as='h2'>
          <Icon name={icon} />
          <Header.Content>
            { title }

            {
              description && (
                <Header.Subheader>
                  { description }
                </Header.Subheader>  
              )
            }
          </Header.Content>
        </Header>

        <div className="extra">
          { this.props.children }
        </div>

      </div>
    )
  }
}